(function($) {
    $(document).on('facetwp-loaded', function() {
        $.each(FWP.settings.num_choices, function(key, val) {
            var $parent = $('.facetwp-facet-' + key).closest('.facetwp-facet');
            (0 === val) ? $parent.hide() : $parent.show();
        });
    });
})(jQuery);